import { createSelector } from '@ngrx/store';
import { IAppState } from '../state/app-config.state';
import { PaymentState } from '../state/payment.state';

const paymentState = (state: IAppState) => state.payment;

export const shouldSaveCard = createSelector(paymentState, (state: PaymentState) => state.newCardDetails.shouldSavedCard);
